import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';
import VideoCurso from '../CursoDetalle/VideoCurso';
import SeccionRelacionados, { TituloSeccion } from './SeccionRelacionados';

const API_PAGA = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';

/* ── Icons ── */
const IconBack     = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M16 10H4M9 14l-5-4 5-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16" style={{flexShrink:0}}><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPdf      = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconKit      = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><rect x="2" y="7" width="20" height="15" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconGame     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><rect x="2" y="6" width="20" height="12" rx="4" stroke="currentColor" strokeWidth="2"/><path d="M7 12h4M9 10v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="16" cy="12" r="1.5" fill="currentColor"/></svg>);
const IconHeart    = ({ on }) => (<svg viewBox="0 0 24 24" width="15" height="15"><path d="M12 21s-7.5-4.6-9.4-9A5.3 5.3 0 0112 5.7 5.3 5.3 0 0121.4 12c-1.9 4.4-9.4 9-9.4 9z" fill={on?'#e63946':'none'} stroke="#e63946" strokeWidth="1.8" strokeLinejoin="round"/></svg>);
const IconTag      = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="7" cy="7" r="1.5" fill="currentColor"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconShield   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20" style={{animation:'rd-spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* Iconos de la ficha */
const FiAge   = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M9 10h.01M15 10h.01M8.5 14.5a4.5 4.5 0 007 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>);
const FiUsers = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="9" cy="7" r="3.2" stroke="currentColor" strokeWidth="1.8"/><path d="M3 21v-1.5A4 4 0 017 15.5h4a4 4 0 014 4V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>);
const FiClock = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>);
const FiFile  = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.8"/></svg>);

const colorMap = {
  verde:    { bg:'linear-gradient(135deg,#d4f4e8,#82D8B3)', text:'#0f3525' },
  azul:     { bg:'linear-gradient(135deg,#dbeafe,#60a5fa)', text:'#1e3a5f' },
  amarillo: { bg:'linear-gradient(135deg,#fef9c3,#fbbf24)', text:'#713f12' },
  rosa:     { bg:'linear-gradient(135deg,#fce7f3,#f9a8d4)', text:'#831843' },
  morado:   { bg:'linear-gradient(135deg,#ede9fe,#a78bfa)', text:'#3b0764' },
  gris:     { bg:'linear-gradient(135deg,#f3f8f5,#82D8B3)', text:'#0f3525' },
};
const TIPO_ICON  = { recurso:<IconPdf/>, kit:<IconKit/>, juego:<IconGame/> };
const TIPO_LABEL = { recurso:'PDF Imprimible', kit:'Cuadernillo', juego:'Juego terapéutico' };

/* ── Galería ── */
function Galeria({ imagenes, imagenPortada, color }) {
  const col = colorMap[color] || colorMap.verde;
  const todas = [
    ...(imagenPortada ? [{ url: imagenPortada, id: 'portada' }] : []),
    ...(imagenes || []),
  ];
  const [activa, setActiva] = useState(0);

  if (todas.length === 0) {
    return (
      <div style={{ width:'100%', aspectRatio:'4/3', borderRadius:6, background:col.bg,
        display:'flex', alignItems:'center', justifyContent:'center', color:col.text }}>
        <div style={{ opacity:.4, transform:'scale(2)' }}>{TIPO_ICON['recurso']}</div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ width:'100%', aspectRatio:'4/3', borderRadius:6, overflow:'hidden',
        background:'#f3f8f5', position:'relative', marginBottom:'.7rem' }}>
        <img src={todas[activa].url} alt={`Vista ${activa+1}`}
          style={{ width:'100%', height:'100%', objectFit:'contain', background:'#f3f8f5' }}/>
        {todas.length > 1 && (
          <>
            <button onClick={()=>setActiva(a=>(a-1+todas.length)%todas.length)} aria-label="Anterior"
              style={{ position:'absolute', left:14, top:'50%', transform:'translateY(-50%)', background:'#8BCAAF', border:'none', color:'#fff', borderRadius:'50%', width:40, height:40, cursor:'pointer', fontSize:'1.3rem', display:'flex', alignItems:'center', justifyContent:'center' }}>‹</button>
            <button onClick={()=>setActiva(a=>(a+1)%todas.length)} aria-label="Siguiente"
              style={{ position:'absolute', right:14, top:'50%', transform:'translateY(-50%)', background:'#8BCAAF', border:'none', color:'#fff', borderRadius:'50%', width:40, height:40, cursor:'pointer', fontSize:'1.3rem', display:'flex', alignItems:'center', justifyContent:'center' }}>›</button>
          </>
        )}
      </div>

      {todas.length > 1 && (
        <div style={{ display:'flex', gap:'.5rem', overflowX:'auto', paddingBottom:'.2rem' }}>
          {todas.map((img, i)=>(
            <button key={img.id||i} onClick={()=>setActiva(i)}
              style={{ width:72, height:60, borderRadius:4, overflow:'hidden', flexShrink:0,
                border: i===activa ? '2px solid #4db88a' : '1px solid rgba(0,0,0,.1)',
                padding:0, cursor:'pointer', background:'#f3f8f5' }}>
              <img src={img.url} alt={`Mini ${i+1}`} style={{ width:'100%', height:'100%', objectFit:'contain' }}/>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

/* ════════════════════════════════════════ */
export default function RecursoDetalle() {
  const { id }   = useParams();
  const navigate = useNavigate();
  const { agregarItem, estaEnCarrito } = useCart();
  const { estaLogueado } = useAuthUser();

  const [recurso, setRecurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  const enCarrito = recurso ? estaEnCarrito(recurso.id) : false;

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    fetch(`${API_PAGA}?action=detail&id=${id}`)
      .then(r => r.json())
      .then(j => { j.success ? setRecurso(j.data) : setError('Material no encontrado'); })
      .catch(() => setError('Error de conexión'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'1rem',color:'#5a6a63'}}>
        <IconSpinner/><p>Cargando material…</p>
      </div>
      <style>{`@keyframes rd-spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );

  if (error || !recurso) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif"}}>
      <div style={{textAlign:'center'}}>
        <p style={{fontSize:'3rem',marginBottom:'1rem'}}>😕</p>
        <h2 style={{marginBottom:'.5rem'}}>Material no encontrado</h2>
        <button onClick={()=>navigate('/recursos')} style={{background:'#111614',color:'#82D8B3',border:'none',borderRadius:100,padding:'.75rem 1.5rem',fontFamily:'inherit',fontWeight:700,cursor:'pointer'}}>
          Volver a materiales
        </button>
      </div>
    </div>
  );

  const col    = colorMap[recurso.color] || colorMap.verde;
  const precio = parseFloat(recurso.precio || 0);
  const pAntes = recurso.precio_antes ? parseFloat(recurso.precio_antes) : null;
  const ahorro = pAntes ? (pAntes - precio).toFixed(0) : null;
  const tags   = Array.isArray(recurso.tags) ? recurso.tags : [];

  /* Ficha compacta junto al precio */
  const ficha = [];
  if (recurso.edad_minima) ficha.push({ icon:<FiAge/>, txt:`A partir de ${recurso.edad_minima} años` });
  if (recurso.jugadores_min || recurso.jugadores_max) {
    const t = recurso.jugadores_min && recurso.jugadores_max
      ? (recurso.jugadores_min === recurso.jugadores_max ? `${recurso.jugadores_min}` : `De ${recurso.jugadores_min} a ${recurso.jugadores_max}`)
      : `${recurso.jugadores_min || recurso.jugadores_max}`;
    ficha.push({ icon:<FiUsers/>, txt:t });
  }
  if (recurso.duracion_min || recurso.duracion_max) {
    const t = recurso.duracion_min && recurso.duracion_max && recurso.duracion_min !== recurso.duracion_max
      ? `De ${recurso.duracion_min} a ${recurso.duracion_max} min`
      : `${recurso.duracion_min || recurso.duracion_max} min`;
    ficha.push({ icon:<FiClock/>, txt:t });
  }
  if (recurso.formato) ficha.push({ icon:<FiFile/>, txt: recurso.paginas ? `${recurso.formato} · ${recurso.paginas} páginas` : recurso.formato });
  if (recurso.nivel)   ficha.push({ icon:null, txt:`Nivel: ${recurso.nivel}` });

  const agregar = () => {
    if (!estaLogueado) { navigate('/login?redirect=/recursos/' + id); return; }
    agregarItem({
      id: recurso.id, titulo: recurso.titulo, precio,
      tipo: recurso.tipo, color: recurso.color,
      imagen: recurso.imagen_url || null,
      descripcion_larga: recurso.descripcion_larga || null,
      imagenes: recurso.imagenes || [],
      es_fisico: !!recurso.es_fisico,
      stock:     recurso.stock ?? null,
      dias_entrega: recurso.dias_entrega || null,
      digital: !recurso.es_fisico,
    });
  };

  return (
    <div style={{minHeight:'100vh',background:'#f3f8f5',fontFamily:"'DM Sans',sans-serif",color:'#111614'}}>
      <style>{`
        @keyframes rd-spin{to{transform:rotate(360deg)}}
        @keyframes rd-fadein{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}
        .rd-top{animation:rd-fadein .4s ease}
        .rd-btn-primary{background:#111614;color:#82D8B3;border:none;border-radius:100px;padding:.95rem 2rem;font-family:inherit;font-weight:700;font-size:.95rem;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:.5rem;width:100%;transition:all .2s}
        .rd-btn-primary:hover{background:#1a2e26;transform:translateY(-1px)}
        .rd-tag{display:inline-flex;align-items:center;gap:.3rem;background:#edfaf4;color:#0f3525;border-radius:100px;padding:.3rem .75rem;font-size:.75rem;font-weight:600}
        @media(max-width:760px){
          .rd-top{grid-template-columns:1fr!important;gap:1.5rem!important}
          .rd-top > div:first-child{position:static!important}
        }
      `}</style>

      {/* NAV */}
      <nav style={{background:'#fff',borderBottom:'1px solid rgba(130,216,179,.2)',padding:'.9rem 5%',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,zIndex:50}}>
        <button onClick={()=>navigate('/recursos')}
          style={{display:'flex',alignItems:'center',gap:'.4rem',background:'none',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:100,padding:'.45rem 1rem',fontFamily:'inherit',fontWeight:600,fontSize:'.85rem',color:'#5a6a63',cursor:'pointer'}}>
          <IconBack/> Volver a materiales
        </button>
        <Link to="/" style={{display:'flex',alignItems:'center',textDecoration:'none'}}>
          <img src="/images/logo_centro.png" alt="Comunicar" style={{height:44,width:'auto',display:'block'}}/>
        </Link>
        <button onClick={()=>navigate('/carrito')}
          style={{display:'flex',alignItems:'center',gap:'.4rem',background:'none',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:100,padding:'.45rem 1rem',fontFamily:'inherit',fontWeight:600,fontSize:'.85rem',color:'#5a6a63',cursor:'pointer'}}>
          <IconCart/> Carrito
        </button>
      </nav>

      {/* ══ BLOQUE SUPERIOR: galería + datos ══ */}
      <div className="rd-top" style={{maxWidth:1040,margin:'0 auto',padding:'2.2rem 5% 1rem',display:'grid',gridTemplateColumns:'1fr 1fr',gap:'2.6rem',alignItems:'start'}}>

        <div style={{position:'sticky',top:90}}>
          <Galeria imagenes={recurso.imagenes || []} imagenPortada={recurso.imagen_url} color={recurso.color}/>
          <div style={{display:'flex',gap:'.5rem',flexWrap:'wrap',marginTop:'.9rem'}}>
            {[{icon:'📥',label:'Descarga inmediata'},{icon:'🖨️',label:'Listo para imprimir'}].map(({icon,label})=>(
              <span key={label} style={{display:'flex',alignItems:'center',gap:'.3rem',background:'#fff',border:'1px solid rgba(130,216,179,.25)',borderRadius:100,padding:'.3rem .75rem',fontSize:'.72rem',fontWeight:600,color:'#5a6a63'}}>
                {icon} {label}
              </span>
            ))}
          </div>
        </div>

        <div style={{display:'flex',flexDirection:'column',gap:'.9rem'}}>

          {/* Categoría + precio */}
          <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'1rem',flexWrap:'wrap'}}>
            <div style={{display:'flex',gap:'.5rem',alignItems:'center',flexWrap:'wrap'}}>
              <span style={{background:col.bg,color:col.text,borderRadius:4,padding:'.25rem .7rem',fontSize:'.73rem',fontWeight:700}}>
                {recurso.categoria}
              </span>
              {recurso.badge && (
                <span style={{background:'#111614',color:'#82D8B3',borderRadius:4,padding:'.25rem .7rem',fontSize:'.7rem',fontWeight:700}}>
                  {recurso.badge}
                </span>
              )}
            </div>
            <div style={{textAlign:'right'}}>
              <span style={{fontSize:'1.7rem',fontWeight:800,color:'#111614',lineHeight:1}}>s/{precio.toFixed(2)}</span>
              {pAntes && <s style={{display:'block',fontSize:'.9rem',color:'#9ca3af',marginTop:'.15rem'}}>s/{pAntes.toFixed(2)}</s>}
            </div>
          </div>

          {/* Título */}
          <h1 style={{fontSize:'1.75rem',fontWeight:800,lineHeight:1.2,color:'#14736C',margin:0}}>
            {recurso.titulo}
          </h1>

          {/* Rating en corazones */}
          {recurso.rating > 0 && (
            <div style={{display:'flex',alignItems:'center',gap:'.4rem'}}>
              <div style={{display:'flex',gap:2}}>
                {[1,2,3,4,5].map(n => <IconHeart key={n} on={n <= Math.round(recurso.rating)}/>)}
              </div>
              {recurso.ventas > 0 && <span style={{color:'#5a6a63',fontSize:'.8rem'}}>· {recurso.ventas} ventas</span>}
            </div>
          )}

          {/* Descripción corta */}
          {recurso.descripcion && (
            <p style={{fontSize:'.92rem',lineHeight:1.65,color:'#5a6a63',margin:0}}>
              {recurso.descripcion}
            </p>
          )}

          {/* Ficha compacta */}
          {(ficha.length > 0 || recurso.codigo) && (
            <div style={{display:'flex',flexDirection:'column',gap:'.4rem',marginTop:'.2rem'}}>
              {ficha.map((f,i)=>(
                <div key={i} style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.85rem',color:'#374151'}}>
                  <span style={{color:'#5a6a63',display:'flex'}}>{f.icon}</span>{f.txt}
                </div>
              ))}
              {recurso.codigo && (
                <div style={{fontSize:'.85rem',color:'#374151',paddingLeft:'1.5rem'}}>
                  <strong>Código:</strong> {recurso.codigo}
                </div>
              )}
            </div>
          )}

          {/* ¿Qué incluye? */}
          <div style={{display:'flex',flexDirection:'column',gap:'.4rem',marginTop:'.4rem'}}>
            <p style={{fontSize:'.73rem',fontWeight:700,color:'#4db88a',textTransform:'uppercase',letterSpacing:'.1em',margin:0}}>
              ¿Qué incluye?
            </p>
            {['Archivo listo para descargar e imprimir','Acceso inmediato tras validar el pago','Soporte por WhatsApp'].map(item => (
              <div key={item} style={{display:'flex',alignItems:'center',gap:'.5rem',fontSize:'.83rem',color:'#374151'}}>
                <IconCheck/> {item}
              </div>
            ))}
          </div>

          {/* Tags */}
          {tags.length > 0 && (
            <div style={{display:'flex',gap:'.4rem',flexWrap:'wrap'}}>
              {tags.map(t => <span key={t} className="rd-tag"><IconTag/>{t}</span>)}
            </div>
          )}

          {/* CTA */}
          <div style={{display:'flex',flexDirection:'column',gap:'.6rem',paddingTop:'.4rem'}}>
            {enCarrito ? (
              <button className="rd-btn-primary" onClick={() => navigate('/carrito')}>
                <IconCart/> Ver en el carrito
              </button>
            ) : (
              <button className="rd-btn-primary" onClick={agregar}>
                <IconCartPlus/> Agregar al carrito
              </button>
            )}
            <a href={`https://wa.me/51940686868?text=${encodeURIComponent('Hola, me interesa el material: ' + recurso.titulo)}`}
              target="_blank" rel="noopener noreferrer"
              style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'.5rem',background:'#25d366',color:'#fff',border:'none',borderRadius:100,padding:'.85rem 2rem',fontFamily:'inherit',fontWeight:700,fontSize:'.88rem',cursor:'pointer',textDecoration:'none'}}>
              <IconWhatsapp/> Consultar por WhatsApp
            </a>
          </div>

          {/* Garantías */}
          <div style={{display:'flex',gap:'1rem',justifyContent:'center',flexWrap:'wrap',paddingTop:'.6rem',borderTop:'1px solid rgba(130,216,179,.15)'}}>
            {[{icon:<IconShield/>,label:'Pago seguro'},{icon:<IconDownload/>,label:'Descarga inmediata'},{icon:<IconCheck/>,label:'Soporte incluido'}].map(({icon,label})=>(
              <div key={label} style={{display:'flex',alignItems:'center',gap:'.3rem',fontSize:'.74rem',color:'#5a6a63',fontWeight:600}}>
                {icon} {label}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ══ ANCHO COMPLETO: descripción, video, relacionados ══ */}
      <div style={{maxWidth:1040,margin:'0 auto',padding:'1.6rem 5% 4rem'}}>

        {(recurso.descripcion_larga || recurso.descripcion) && (
          <section style={{marginBottom:'2.4rem'}}>
            <TituloSeccion a="Descripción" b="del producto"/>
            <p style={{fontSize:'.92rem',lineHeight:1.85,color:'#4b5563',margin:0,whiteSpace:'pre-line',textAlign:'justify'}}>
              {recurso.descripcion_larga || recurso.descripcion}
            </p>
          </section>
        )}

        {recurso.video_url && (
          <section style={{marginBottom:'2.8rem'}}>
            <VideoCurso url={recurso.video_url} titulo={recurso.titulo}/>
          </section>
        )}

        <SeccionRelacionados
          origenTipo="recurso"
          origenId={recurso.id}
          origenTitulo={recurso.titulo}
          origenPrecio={precio}
          origenImagen={recurso.imagen_url}
          redirectLogin={`/login?redirect=/recursos/${id}`}
        />
      </div>
    </div>
  );
}